import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'employee-lifecycle',
  children: {
    workflows: {
      path: 'workflows',
      children: {
        onboarding: {
          path: 'onboarding',
        },
        id: {
          path: ':id',
          children: {
            edit: {
              path: 'edit',
            },
          },
        },
      },
    },
    workflowType: {
      path: ':workflowType',
    },
    smartOnboarding: {
      path: 'smart-onboarding',
      children: {
        policies: {
          path: 'policies',
        },
        plans: {
          path: 'plans',
        },
      },
    },
  },
} as const satisfies Location
